import apiService from '../utils/apiService';

const getAuthConfig = () => {
  const token = localStorage.getItem('m_a_t');
  return token
    ? {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    : {};
};

const mgmAuth = async (telegramId) => {
  const response = await apiService.post('mgm/auth', {
    data: {
      telegramId
    }
  });

  return response?.data;
};

const generateQrCode = async () => {
  const response = await apiService.get('mgm/qr/generate', getAuthConfig());

  return response?.data;
};

const getMe = async () => {
  const response = await apiService.get('mgm/me', getAuthConfig());

  return response?.data;
};

const validateQrCode = async (token) => {
  const response = await apiService.post('mgm/qr/validate', {
    data: {
      token
    },
    ...getAuthConfig()
  });

  return response?.data;
};

const getCertificates = async (nominal, partnerId) => {
  const response = await apiService.get('mgm/certificates', {
    params: {
      nominal,
      partnerId
    },
    ...getAuthConfig()
  });

  return response?.data;
};

const buyCertificate = async (id, number) => {
  const response = await apiService.post(`mgm/certificates/${id}/buy`, {
    ...(number ? { data: { number } } : {}),
    ...getAuthConfig()
  });

  return response?.data;
};

const getBalance = async () => {
  const response = await apiService.get('mgm/me/balance', getAuthConfig());

  return response?.data;
};

const getBalanceHistory = async (page, limit, operationType) => {
  const response = await apiService.get('mgm/me/balance/history', {
    params: {
      page,
      limit,
      operationType
    },
    ...getAuthConfig()
  });

  return response?.data;
};

const getRewards = async (page, limit) => {
  const response = await apiService.get('mgm/me/rewards', {
    params: {
      page,
      limit
    },
    ...getAuthConfig()
  });

  return response?.data;
};

const getRewardById = async (id) => {
  const response = await apiService.get(
    `mgm/me/rewards/${id}`,
    getAuthConfig()
  );

  return response?.data;
};

const getQrCodes = async (page, limit) => {
  const response = await apiService.get('mgm/me/qr-codes', {
    params: {
      page,
      limit
    },
    ...getAuthConfig()
  });

  return response?.data;
};

const getQrCodeById = async (id) => {
  const response = await apiService.get(
    `mgm/me/qr-codes/${id}`,
    getAuthConfig()
  );

  return response?.data;
};

const regenerateQrCode = async (id) => {
  const response = await apiService.post(
    `mgm/me/qr-codes/${id}/regenerate`,
    getAuthConfig()
  );

  return response?.data;
};

const createFeedback = async (name, email, comment) => {
  const response = await apiService.post('mgm/feedback', {
    data: {
      name,
      email,
      comment
    },
    ...getAuthConfig()
  });

  return response?.data;
};

export default {
  mgmAuth,
  generateQrCode,
  validateQrCode,
  getCertificates,
  buyCertificate,
  getBalance,
  getBalanceHistory,
  getRewards,
  getRewardById,
  getQrCodes,
  getQrCodeById,
  regenerateQrCode,
  createFeedback,
  getMe
};
